"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var object_to_kv_1 = require("./object_to_kv");
// tslint:disable-next-line:no-any
function ensureErrorIsError(error) {
    return error instanceof Error ? error : new Error(String(error));
}
function getErrorInfoFromError(error) {
    var other = Object.keys(error)
        .filter(function (key) { return key !== 'name' && key !== 'message' && key !== 'stack'; })
        .reduce(function (acc, key) {
        acc[key] = error[key]; // tslint:disable-line:no-any
        return acc;
    }, {}); // tslint:disable-line:no-any
    return {
        name: String(error.name || error.constructor.name || ''),
        message: String(error.message),
        stack: String(error.stack),
        other: object_to_kv_1.convertDeepObjectToKV(other),
    };
}
var BaseLogger = (function () {
    function BaseLogger(messageWriter, errorWriter, application, environment, release) {
        this.messageWriter = messageWriter;
        this.errorWriter = errorWriter;
        this.application = application;
        this.environment = environment;
        this.release = release;
    }
    BaseLogger.prototype.debug = function (message, meta) {
        this.messageWriter.write(JSON.stringify(this.prepareMessageEnvelope('debug', message, meta)));
    };
    BaseLogger.prototype.info = function (message, meta) {
        this.messageWriter.write(JSON.stringify(this.prepareMessageEnvelope('info', message, meta)));
    };
    BaseLogger.prototype.warning = function (message, meta) {
        this.messageWriter.write(JSON.stringify(this.prepareMessageEnvelope('warning', message, meta)));
    };
    // tslint:disable-next-line:no-any
    BaseLogger.prototype.error = function (error, meta) {
        this.errorWriter.write(JSON.stringify(this.prepareErrorEnvelope(ensureErrorIsError(error), meta)));
    };
    BaseLogger.prototype.prepareMessageEnvelope = function (level, message, meta) {
        return {
            type: 'nodejs-messages',
            level: level,
            message: message,
            date: (new Date()).toISOString(),
            application: this.application,
            environment: this.environment,
            release: this.release,
            meta: meta ? object_to_kv_1.convertDeepObjectToKV(meta) : [],
        };
    };
    BaseLogger.prototype.prepareErrorEnvelope = function (error, meta) {
        var errorInfo = getErrorInfoFromError(error);
        var cause = [];
        var currentError = error;
        // tslint:disable-next-line:no-any
        while (currentError.cause) {
            // tslint:disable-next-line:no-any
            currentError = currentError.cause;
            cause.push(getErrorInfoFromError(currentError));
        }
        return {
            type: 'nodejs-errors',
            name: errorInfo.name,
            message: errorInfo.message,
            stack: errorInfo.stack,
            other: errorInfo.other,
            cause: cause,
            date: (new Date()).toISOString(),
            application: this.application,
            environment: this.environment,
            release: this.release,
            meta: meta ? object_to_kv_1.convertDeepObjectToKV(meta) : [],
        };
    };
    return BaseLogger;
}());
exports.BaseLogger = BaseLogger;
//# sourceMappingURL=base_logger.js.map